import React from "react";
import Dropzone from "react-dropzone";
import { updateApp, uploadFile, getApp,PWA2APK_PAYMENT_REDIRECT_URL } from "../../../api";
import Payment from "../../../payment";
import Track from "../../../track";
class StepOneForm extends React.Component {
  state = {
    name:  "",
    icon:  "",
    email: "",
    formValues:{},
    showCustomPackageName:false,
    showUpladingProgress: false,
    showCustomIconUpload: false,
    packagename:"xyz.appmaker.appsss",
    loading: false,
    contentLoading:true,
    premium:true,
    errMessage: ""
  };
  componentDidMount() {
    this.payment = new Payment({
      onSuccess:console.log
    });
    getApp(this.props.match.params.appId).then((response)=>{
      this.setState({
        contentLoading:false,
        formValues:response,
        name:response.name,
        icon:response.icon,
        url:response.url,
        email:response.email,
        packagename:response.package_name,
      })
    })
  }
  //cn121589 - 2060- 
  handleChange = field => e => this.setState({ [field]: e.target.value });
  onDrop = (acceptedFiles, rejectedFiles) => {
    this.setState(
      {
        showUpladingProgress: true
      },
      () => {
        uploadFile({
          id: this.props.match.params.appId,
          file: acceptedFiles[0]
        }).then(response => {
          if (response.status) {
            this.setState({
              icon: response.icon,
              showUpladingProgress: false,
              showCustomIconUpload: false,
            });
          } else {
          }
        });
      }
    );
  };

  submitUrl = () => {
    if (this.state.email === "") {
      return this.setState({
        errMessage: "Please provide an email address"
      });
    }

    this.setState({
      loading: true,
      errMessage: ""
    });
    updateApp({
      id: this.props.match.params.appId,
      url: this.state.formValues["url"],
      name: this.state.name,
      icon: this.state.icon,
      email: this.state.email,
      customPackageNameEnabled: this.state.showCustomPackageName,
      package_name: this.state.packagename
    }).then(data => {
      if (data.status) {
        this.setState({
          loading: false
        });
        if(data.paymentRequired)
          this.payment
          .setProduct({
            name: "PWA2APK PREMIUM",
            price: window.appmakerProducts.pwaToApkPrice
          })
          .checkout(
            {
              extranalRef:this.props.match.params.appId,
              redirectUrl:PWA2APK_PAYMENT_REDIRECT_URL,
              email:this.state.email
            }
          );
        else
         this.props.history.push("/pwa-to-apk/verification/" + data.id);
      } else {
        this.setState({ loading: false, errMessage: data.error });
      }
    });
  };
  render() {
    return (
      this.state.contentLoading  ? (
        <div className="app-verify text-center m-auto">
          <img
            alt="Loading"
            src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
            className="w-25"
          />
        </div>
      ) : (
        <div className="step-2 col-sm-12 m-auto ">
        <h3>Some details we picked from url provided</h3>
        <h6 className="mb-4">Click next to go with it or edit and proceed.</h6>
        <label htmlFor="name">Name of App</label>
        <div className="appname d-flex">
          <input
            id="name"
            type="text"
            name="name"
            value={this.state.name}
            onChange={this.handleChange("name")}
            className="flex-grow-1"
          />
          <label htmlFor="name" className="like-href">
            <i className="fas fa-pencil-alt" />
          </label>
        </div>
        
        
        <div className="mt-3 mb-3 pro-switch">
          <label className="switch">
            <input type="checkbox" onChange={(e)=>{
               Track.event({
                category: "PWA2APK-Premium",
                action: "Click",
                label:e.target.checked.toString()
              });
              this.setState({
                showCustomPackageName:!this.state.showCustomPackageName
              })
            }} /> 
            <span className="slider round"></span> 
          </label>
          <p className="d-inline-block ml-3 mb-0">Custom Package Name<span class=" ml-2 badge badge-success">+${window.appmakerProducts.pwaToApkPrice}</span></p><br />
        </div>
        {this.state.showCustomPackageName && (<div>
          <label htmlFor="packagename">Package Name</label>
        <div className="packagename d-flex justify-content-between">

          <input
            id="name"
            type="text"
            name="packagename"
            value={this.state.packagename}
            onChange={this.handleChange("packagename")}
            className="flex-grow-1"
          />
          <label htmlFor="packagename" className="like-href mt-auto">
            <i className="fas fa-pencil-alt" />
          </label>
          <div className="pro-icon">
            <label>Pro</label>
          </div>
        </div>

        </div>)}
        
        <label htmlFor="appicon">App Icon</label>
        <div className="appicon d-flex">
          <div className="flex-grow-1">
            <img src={this.state.icon} alt="" />
          </div>
          <div
            className="like-href"
            onClick={e => {
              this.setState({
                showCustomIconUpload: !this.state.showCustomIconUpload
              });
            }}
          >
            <i className="fas fa-pencil-alt" />
          </div>
        </div>
        {this.state.showUpladingProgress ? (
          <div className="text-center m-4">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.showCustomIconUpload && (
          <Dropzone onDrop={this.onDrop.bind(this)}
          accept="image/*"
          >
            {({ getRootProps, getInputProps, isDragActive }) => {
              return (
                <div {...getRootProps()} className={"dropzone box text-center"}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p>Drop files here...</p>
                  ) : (
                    <div className="box_input">
                      <i className="fas fa-cloud-upload-alt uplaod_icon d-block" />
                      <label htmlFor="file">
                        <strong>Choose a file</strong>
                        <span className="box_dragndrop"> or drag it here</span>
                      </label>
                      <br />
                    </div>
                  )}
                </div>
              );
            }}
          </Dropzone>
        )}
        <div className="app-verify text-center">
          <h6 className="text-left">
          We’ll email you the APK file (Playstore ready), to upload from Playstore Developer Account
          </h6>
          <div className="input-group">
            <input
              type="email"
              className="form-control"
              id="email"
              onChange={this.handleChange("email")}
              placeholder="Email Id"
            />
          </div>
        </div>
        {this.state.errMessage ? (
          <div className="alert alert-danger" role="alert">
            {this.state.errMessage}
          </div>
        ) : (
          ""
        )}
        <button className="btn btn-success w-100" onClick={this.submitUrl}>
          {this.state.loading ? (
            <span
              className="spinner-grow spinner-grow-sm mr-4"
              role="status"
              aria-hidden="true"
            />
          ) : (
            ""
          )}
          {this.state.showCustomPackageName ? "Make payment $"+window.appmakerProducts.pwaToApkPrice : "Create Now "}
        </button>
      </div>
      )      
    );
  }
}

export default StepOneForm;
